import React from "react"
import { FormattedMessage, useIntl } from "gatsby-plugin-react-intl"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { StaticImage } from "gatsby-plugin-image"

import { ArrowUp } from "../components/Navbar/NavbarElements"

import scrollTo from 'gatsby-plugin-smoothscroll';

const IndexPage = () => {
  const intl = useIntl()
  return (
    <Layout>
      <SEO
        lang={intl.locale}
        title={intl.formatMessage({ id: "title" })}
        keywords={[`gatsby`, `application`, `react`]}
      />
      <div className="intro-container">
      <div className="intro-inner">
        <div className="text-block">
          <h4 className="Title">
            <FormattedMessage id="header" />
          </h4>
          <div className="divider centered"></div>
          <p>
            <FormattedMessage id="intro" />
          </p>
        </div>

      <StaticImage
          src="../images/intro.jpg"
          quality={50}
          formats={["AUTO", "WEBP", "AVIF"]}
          alt="Pizza"
          className="intro-banner"
        />
        </div>
      </div>
      <div id="start"></div>
      <div className="kunstwerk-container">
        <div className="kunstwerk-inner">
        <div className="text-block">
            <h4 className="Title">
              <FormattedMessage id="kunstwerk" />
            </h4>
            <div className="divider"></div>
            <p>
              <FormattedMessage id="kunstwerk-tekst1" />
            </p>
            <p className="quote">
              <FormattedMessage id="kunstwerk-tekst2" />
            </p>
            <p>
              <FormattedMessage id="kunstwerk-tekst3" />
            </p>
            <p>
              <FormattedMessage id="kunstwerk-tekst4" />
            </p>
            <p className="quote">
              <FormattedMessage id="kunstwerk-tekst5" />
            </p>
          </div>
          <div id="galerij"></div>
          <div className="galerij-wrapper">
          <div className="image">
          <StaticImage
            src="../images/kunstwerk1.jpg"
            quality={50}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="Pizza"
            className=""
          />
          </div>
          <div className="image">
          <StaticImage
            src="../images/kunstwerk2.jpg"
            quality={50}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="Pizza"
            className=""
          />
          </div>
          <div className="image">
          <StaticImage
            src="../images/kunstwerk3.jpg"
            quality={50}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="Pizza"
            className=""
          />
          </div>
          <div className="image">
          <StaticImage
            src="../images/kunstwerk4.jpg"
            quality={50}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="Pizza"
            className=""
          />
          </div>
          </div>
        </div>
      </div>
      <div className="project-container">
        <div className="project-inner">
          <div className="text-block">
            <h4 className="Title">
              <FormattedMessage id="project" />
            </h4>
            <div className="divider"></div>
            <p>
              <FormattedMessage id="project1" />
            </p>
            <p>
              <FormattedMessage id="project2" />
            </p>
            <p>
              <FormattedMessage id="project3" />
            </p>
          </div>
          <div className="logo-wrap">
            <div className="logo-item">
              <StaticImage
              src="../images/logos/nef.png"
              formats={["AUTO", "WEBP", "AVIF"]}
              alt="Pizza"
              className=""
              />
            </div>
            <div className="logo-item">
              <StaticImage
              src="../images/logos/fryslan.png"
              formats={["AUTO", "WEBP", "AVIF"]}
              alt="Pizza"
              className="more-padding"
              />
            </div>
            <div className="logo-item">
              <StaticImage
              src="../images/logos/burum.png"
              formats={["AUTO", "WEBP", "AVIF"]}
              alt="Pizza"
              className=""
              />
            </div>
            <div className="logo-item">
              <StaticImage
              src="../images/logos/pbc.png"
              formats={["AUTO", "WEBP", "AVIF"]}
              alt="Pizza"
              className=""
              />
            </div>
            <div className="logo-item">
              <StaticImage
              src="../images/logos/bpd.png"
              formats={["AUTO", "WEBP", "AVIF"]}
              alt="Pizza"
              className="more-padding"
              />
            </div>
            <div className="logo-item">
              <StaticImage
              src="../images/logos/vanlingen.png"
              formats={["AUTO", "WEBP", "AVIF"]}
              alt="Pizza"
              className=""
              />
            </div>
            <div className="logo-item">
              <StaticImage
              src="../images/logos/wiersma-reitsma.png"
              formats={["AUTO", "WEBP", "AVIF"]}
              alt="Pizza"
              className=""
              />
            </div>
          </div>
        </div>
      </div>

      <div className="kunstenaar-container">
        <div className="text-block">
          <h4 className="Title">
            <FormattedMessage id="kunstenaar" />
          </h4>
          <div className="divider"></div>
          <p>
            <FormattedMessage id="kunstenaar1" />
          </p>
          <p>
            <FormattedMessage id="kunstenaar2" />
          </p>
          <StaticImage
          src="../images/heleen.jpg"
          quality={50}
          formats={["AUTO", "WEBP", "AVIF"]}
          className="extra-margin"
        />
          <p className="quote">
            <FormattedMessage id="kunstenaar3" />
          </p>
          <p>
            <FormattedMessage id="kunstenaar4" />
          </p>
        </div>
      </div>
      <footer>
        <div className="seperator"></div>
        <div className="footer-links">
          <div>
            <div className="full">
              <p>© Heleen Kater, 2021</p>
            </div>
          </div>
          <div>
            <div className="full">
              <div onClick={() => scrollTo('#top')}><ArrowUp /></div>
            </div>
          </div>
        </div>
      </footer>
    </Layout>
  )
}

export default IndexPage
